<template>
  <div class="mobile-step5-container">
    <div class="mobile-step5-header">
      <p class="mobile-step5-title">即将提交您的信息，请确认以下内容正确</p>
    </div>

    <div class="mobile-step5-content">
      <!-- 产品信息 -->
      <van-cell-group title="产品信息">
        <van-cell title="产品型号" :value="repair.details[0].model" />
        <van-cell title="寄修部件" :value="fittingsData.map(item => item.name).join('/')" />
      </van-cell-group>

      <!-- 购买凭证 -->
      <van-cell-group
        v-if="repair.details[0].purchases && repair.details[0].purchases.length"
        title="购买凭证"
      >
        <van-cell
          v-for="(item, index) of repair.details[0].purchases"
          :key="index"
          :title="item.name"
          @click="getOssAttachsUrl(item)"
          is-link
        />
      </van-cell-group>

      <!-- 故障信息 -->
      <van-cell-group title="故障信息描述">
        <van-cell v-if="repair.details[0].desc" title="故障描述" :value="repair.details[0].desc" />
      </van-cell-group>

      <!-- 附件 -->
      <van-cell-group v-if="repair.attachs && repair.attachs.length" title="附件">
        <van-cell
          v-for="(item, index) of repair.attachs"
          :key="index"
          :title="item.name"
          @click="getOssAttachsUrl(item)"
          is-link
        />
      </van-cell-group>

      <!-- 寄回信息 -->
      <van-cell-group title="寄回信息（维修后寄回用）">
        <van-cell title="姓名" :value="repair.sendContact" />
        <van-cell title="手机" :value="repair.sendPhone" />
        <van-cell
          v-if="Array.isArray(repair.area) && repair.area.length"
          title="地区"
          :value="repair.area.join('/')"
        />
        <van-cell title="地址" :value="repair.tmpAddress" />
      </van-cell-group>

      <!-- 寄出快递信息 -->
      <van-cell-group title="寄出快递信息">
        <van-cell
          title="快递公司"
          :value="repair.receiveDeliveryInc ? repair.receiveDeliveryInc.text : '暂无'"
        />
        <van-cell title="快递单号" :value="repair.receiveDeliveryCode || '暂无'" />
      </van-cell-group>
    </div>

    <!-- 底部按钮 -->
    <div class="mobile-step5-footer">
      <van-button block plain type="primary" @click="goBack" class="orange empty"
        >返回修改</van-button
      >
      <van-button block type="primary" @click="confirmSubmit" class="orange">确认提交</van-button>
    </div>

    <!-- 附件预览 -->
    <van-image-preview v-model="showViewer" :images="srcList" />

    <!-- 视频预览 -->
    <div class="video-component" v-if="showVideo" @click="closeVideo">
      <div class="video-close-btn" @click.stop="closeVideo">
        <van-icon name="cross" />
      </div>
      <video controls @click.stop class="video-main">
        <source :src="videoSrc" />
      </video>
    </div>

    <!-- 快递信息缺失确认 -->
    <van-dialog
      v-model="dialogVisible"
      title="提示"
      message="快递公司或快递单号为空，是否先提交？"
      show-cancel-button
      @confirm="saveData(-1)"
      @cancel="dialogVisible = false"
      confirm-button-text="是，提交"
      cancel-button-text="否，返回修改"
    />
  </div>
</template>

<script>
/* global OSS */

export default {
  name: 'MobileStep5',
  props: {
    repairData: Object
  },
  data() {
    return {
      repair: {},
      dialogVisible: false,
      srcList: [],
      videoSrc: '',
      showViewer: false,
      showVideo: false,
      fittingsData: []
    }
  },
  methods: {
    async getOssAttachsUrl(item) {
      try {
        let ossClient = await this.getOssClient()
        item.url = ossClient.signatureUrl(item.path, { expires: 3600 })

        if (['jpeg', 'jpg', 'png', 'bmp'].includes(item.format)) {
          this.srcList = [item.url]
          this.showViewer = true
        } else {
          this.videoSrc = item.url
          this.showVideo = true
        }
      } catch (error) {
        console.error(error)
        this.$toast.fail('获取附件失败')
      }
    },

    async getOssClient() {
      try {
        let res = await this.$http.getSts()
        let region = 'oss-cn-shenzhen'
        let bucket = 'onyx-work-order'

        // 安全地引用 OSS 对象，确保它存在
        const OSS = window.OSS || global.OSS || {}
        if (!OSS || typeof OSS.prototype === 'undefined') {
          throw new Error('OSS is not defined')
        }

        let client = new OSS({
          region,
          bucket,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken
        })
        return client
      } catch (error) {
        console.error('获取OSS客户端失败:', error)
        this.$toast.fail('获取文件预览失败')
        throw error
      }
    },

    closeVideo() {
      this.showVideo = false
      this.videoSrc = ''
    },

    setFittingsData() {
      if (this.repair.details[0].fittingsData) {
        this.fittingsData = JSON.parse(JSON.stringify(this.repair.details[0].fittingsData))
      }
    },

    goBack() {
      this.$emit('back')
    },

    confirmSubmit() {
      if (!this.repair.receiveDeliveryInc || !this.repair.receiveDeliveryCode) {
        this.dialogVisible = true
        return
      }

      this.$dialog
        .confirm({
          title: '寄件需知',
          message: `<div style="text-align: left;">1、如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。<br />2、寄修前请自行做好数据备份，因维修导致的数据丢失，文石概不负责；<br />3、快件打包请注意保护好屏幕，避免运输中有损坏；<br />4、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；<br />5、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询；<br />6、经文石检测确认后，需付费维修的设备，从文石发起付费通知七个工作日后如仍未付费确认维修，文石售后维修中心会将设备原路寄回；<br />7、运费双方各支付一程，请勿寄到付，到付拒收；</div>`,
          confirmButtonText: '同意，提交',
          cancelButtonText: '返回',
          showCancelButton: true
        })
        .then(() => {
          this.saveData(0)
        })
        .catch(() => {
          // 取消提交
        })
    },

    saveData(status) {
      this.$emit('saveData', status)
    }
  },
  watch: {
    repairData: {
      handler(val) {
        this.repair = val
        this.setFittingsData()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.repair = this.repairData
    this.setFittingsData()
  }
}
</script>

<style lang="scss" scoped>
.mobile-step5-container {
  padding-bottom: 20px;

  .mobile-step5-header {
    padding: 20px 0 10px;
    text-align: center;

    .mobile-step5-title {
      font-size: 18px;
      font-weight: bold;
      margin: 0;
    }
  }

  .mobile-step5-content {
    ::v-deep .van-cell-group__title {
      padding: 16px 16px 8px;
      font-size: 14px;
      font-weight: bold;
    }

    ::v-deep .van-cell {
      padding: 12px 16px;
    }
  }

  .mobile-step5-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 16px 30px;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    z-index: 10;
  }

  .video-component {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    .video-close-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 32px;
      height: 32px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .van-icon {
        color: #fff;
        font-size: 20px;
      }
    }

    .video-main {
      width: 90%;
      max-width: 500px;
      max-height: 80vh;
    }
  }
}

:deep(.van-cell__value) {
  flex: 4;
}

.orange {
  background-color: #ce653e;
  border-color: #ce653e;

  &.empty {
    color: #ce653e;
    background-color: #fff;
  }
}
</style>
